import { FormEvent, useCallback, useContext, useState } from 'react'

import { Button, Text } from '@hhgtech/hhg-components/mantine'
import { Missed } from '@hhgtech/icons/other'
import { Box, BoxProps } from '@mantine/core'
import { useIntl } from 'react-intl'

import Send from 'components/atoms/icons/Send'

import useStyles from './index.styles'
import { AIChatBotContext } from '../../context'

export type MessageInputProps = {
  disabled?: boolean
  onSubmit: ({ message }: { message: string }) => void
} & BoxProps

export const MessageInput = ({
  children,
  disabled,
  styles,
  classNames,
  className,
  onSubmit,
  ...boxProps
}: MessageInputProps) => {
  const { formatMessage: f } = useIntl()
  const { classes, cx } = useStyles(undefined, {
    name: 'AIChatBotWidget__MessageInput',
    styles,
    classNames,
  })
  const { expandWidget } = useContext(AIChatBotContext)
  const [value, setValue] = useState('')
  const handleSubmit = useCallback(
    (e: FormEvent) => {
      e.preventDefault()
      if (disabled) return false
      const message = value
      if (!message) return
      onSubmit({ message })
      setValue('')
    },
    [value],
  )

  return (
    <form
      className={cx(classes.root, className)}
      onSubmit={handleSubmit}
      {...boxProps}
    >
      <Box className={classes.inputRoot}>
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className={classes.inputInput}
          name="input-message"
          placeholder={f({
            id: 'chatbot.inputPlaceholder',
          })}
        />
        <Box className={classes.rightSection}>
          <Button
            className={cx(classes.submitBtn)}
            disabled={disabled}
            type="submit"
            variant="white"
            leftIcon={<Send size={24} />}
          ></Button>
        </Box>
      </Box>
      {expandWidget && (
        <Box className={classes.disclaimer}>
          <Missed size={14} className={classes.disclaimerIcon} />
          <Text size="n1" className={classes.disclaimerText}>
            {f({ id: 'chatbot.disclaimer' })}
          </Text>
        </Box>
      )}
    </form>
  )
}
